import { logToExternalErrorHandlers } from '../errors';
import { Currency } from './currency';

export const displayCurrencySymbol = (currency: Currency, numberFormat?: Intl.NumberFormat): string => {
    try {
        const format = numberFormat ?? new Intl.NumberFormat('de-DE', { style: 'currency', currency });
        const parts = format.formatToParts(0);
        const currencySymbol = parts.find((p) => p.type === 'currency')?.value;
        return currencySymbol ?? '?';
    } catch {
        logToExternalErrorHandlers(new Error(`Unknown currency code: ${currency}`));
        return '?';
    }
};
